export function closestNiceNumber(value: number): number {
  if (value === 0) return 0;

  const absValue = Math.abs(value);
  const sign = value < 0 ? -1 : 1;

  // Find the order of magnitude
  const magnitude = Math.floor(Math.log10(absValue));
  const powerOf10 = Math.pow(10, magnitude);

  // Normalize to range [1, 10)
  const normalized = absValue / powerOf10;

  // Find closest nice multiplier (1, 2, or 5)
  let niceMultiplier: number;
  if (normalized <= 1.5) {
    niceMultiplier = 1;
  } else if (normalized <= 3.5) {
    niceMultiplier = 2;
  } else if (normalized <= 7) {
    niceMultiplier = 5;
  } else {
    niceMultiplier = 10;
  }

  return sign * niceMultiplier * powerOf10;
}

export interface NiceNumbersResult {
  step: number;
  values: number[];
  count: number;
}

export function calculateNiceNumbers(min: number, max: number, targetSteps = 10): NiceNumbersResult {
  const range = max - min;
  const tolerance = range / targetSteps;

  // Calculate nice step directly
  const selectedStep = closestNiceNumber(tolerance);

  // Calculate values from min to max using the selected step
  const values: number[] = [];
  let current = Math.ceil(min / selectedStep) * selectedStep;

  while (current <= max) {
    values.push(current);
    current += selectedStep;
  }

  return {
    step: selectedStep,
    values,
    count: values.length,
  };
}
